import {gsap} from 'gsap'
import {SplitText} from 'gsap/SplitText'
import {disableScroll, enableScroll} from './utils'

const mainMenu = () => {
  const navSidebar = $('.tr-sidebar-navigation')
  const bgMenu = $('.bg-menu')
  const nav = $('.tr-navigation')
  const header = $('.tr-header')
  const hero_sections = $('.tr-home-hero__container, .tr-hero')
  let scrollOnce = true
  nav.find('.tr-navigation__wrapper').scroll(function () {
    if ($(this).scrollTop() >= 5 && scrollOnce) {
      scrollOnce = false
    }
  })

  const contactsLink = document.querySelectorAll('[href*="#contactForm"]')

  Array.from(contactsLink).forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
    })
    link.dataset.modalBtn = 'become-member-modal'
  })

  //Mobile animation menu open
  header.find('.tr-header__burger').on('click', function () {
    disableScroll()
    header.addClass('open')
    gsap.to($(this), {opacity: 0, visibility: 'hidden'})
    gsap.to(header.find('.tr-header__btn-menu'), {opacity: 1, visibility: 'visible'})
    gsap.to(bgMenu, {rotate: '0'})
    gsap.to(nav, {opacity: 1, visibility: 'visible', delay: 0.4})
    gsap.timeline().fromTo(nav.find('.tr-navigation__bg'), {rotate: '90deg'}, {rotate: '0'})
    gsap.timeline()
      .to(header.find('.list-anchor-mob'), {opacity: 0, visibility: 'hidden', height: '0', y: -20})
      .to(header.find('.tr-header__logo'), {opacity: 1, visibility: 'visible', height: '100%', y: 0}, '-=1')
  })

  //Mobile anim menu close
  function closeMenuMobile() {
    scrollOnce = true
    header.removeClass('open')
    gsap.to(header.find('.tr-header__burger'), {opacity: 1, visibility: 'visible'})
    gsap.to(header.find('.tr-header__btn-menu'), {opacity: 0, visibility: 'hidden'})
    gsap.to(nav, {opacity: 0, visibility: 'hidden'})
    gsap.to(bgMenu, {rotate: '-90deg'})
    if ($(window).scrollTop() >= 150) {
      gsap.timeline()
        .to(header.find('.tr-header__logo'), {opacity: 0, visibility: 'hidden', height: 0, y: -20})
        .to(header.find('.list-anchor-mob'), {opacity: 1, visibility: 'visible', height: '100%', y: 0})
    } else {
      gsap.timeline()
        .to(header.find('.list-anchor-mob'), {opacity: 0, visibility: 'hidden', height: '0', y: -20})
        .to(header.find('.tr-header__logo'), {opacity: 1, visibility: 'visible', height: '100%', y: 0}, '-=1')
    }
    enableScroll()
  }

  header.find('.tr-header__btn-menu--close').on('click', closeMenuMobile)

  //Desktop anim menu close
  function closeMenuDesktop() {
    enableScroll()
    header.removeClass('open')
    scrollOnce = true
    gsap.to(header, {position: 'absolute'})
    gsap.to(nav, {opacity: 0, visibility: 'hidden'})
    gsap.to(bgMenu, {rotate: '-90deg'})
    gsap.to(navSidebar, {opacity: 1, visibility: 'visible'})
    setTimeout(function () {
      hero_sections.each(function () {
        $(this).removeClass("menu-open");
      });
    }, 500)
  }

  nav.find('.tr-navigation__btn-menu--close').on('click', closeMenuDesktop)

  //Desktop anim menu open
  const labelChars = new SplitText($('.tr-navigation__search-form > label'), {
    type: 'chars',
    charsClass: 'wrapped-symbol',
  })
  navSidebar.find('.tr-sidebar-navigation__burger').on('click', () => {
    header.addClass('open')
    hero_sections.each(function () {
      $(this).addClass("menu-open");
    });
    gsap.from(labelChars.chars,
      {
        autoAlpha: 0,
        stagger: {
          each: 0.1,
        },
        duration: 0.1,
      },
    )
    gsap.to(bgMenu, {rotate: '0'})
    gsap.to(navSidebar, {opacity: '0', visibility: 'hidden'})
    gsap.to(nav, {opacity: 1, visibility: 'visible', delay: 0.4})
    gsap.to(header, {position: 'fixed'})
    gsap.timeline()
      .fromTo(nav.find('.tr-navigation__bg'), {rotate: '90deg'}, {rotate: '0'})
      .fromTo(nav.find('.tr-navigation__additional-links'), {y: '20', opacity: 0}, {y: '0', opacity: 1})
    disableScroll()

    if (nav.find('.tr-navigation__container a').length >= 1) {
      setTimeout(() => {
        const currentLink = nav.find('.tr-navigation__container .current-menu-item a')
        if (currentLink.length) {
          currentLink.focus()
        } else {
          nav.find('.tr-navigation__btn-menu--home').focus()
        }
      }, 800)
    }
  })

  let windowWidth = $(window).outerWidth()
  let resizeTimer
  $(window).on('resize', function () {
    if (windowWidth !== $(this).outerWidth()) {
      windowWidth = $(this).outerWidth()
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        gsap.to(nav, {opacity: 0, visibility: 'hidden'})
        gsap.to(bgMenu, {rotate: '-90deg'})
        gsap.to(header.find('.tr-header__burger'), {opacity: 1, visibility: 'visible'})
        gsap.to(header.find('.tr-header__btn-menu'), {opacity: 0, visibility: 'hidden'})

        if ($(this).outerWidth() >= '768') {
          gsap.to(navSidebar, {opacity: 1, visibility: 'visible'})
          gsap.to(header, {position: 'absolute'})
          gsap.to(header.find('.list-anchor-mob'), {opacity: 0, visibility: 'hidden', height: '0', y: -20})
          gsap.to(header.find('.tr-header__logo'), {opacity: 1, visibility: 'visible', height: '100%', y: 0})
        } else {
          gsap.to(header, {position: 'fixed'})
        }
      })
    }
  })

  let scrollFinished
  $(window).on('scroll', function () {
    if ($(this).outerWidth() <= '768') {
      clearTimeout(scrollFinished)
      scrollFinished = setTimeout(() => {
        if ($(this).scrollTop() >= 150) {
          gsap.timeline()
            .to(header.find('.tr-header__logo'), {opacity: 0, visibility: 'hidden', height: 0, y: -20})
            .to(header.find('.list-anchor-mob'), {opacity: 1, visibility: 'visible', height: '100%', y: 0})
        } else {
          gsap.timeline()
            .to(header.find('.list-anchor-mob'), {opacity: 0, visibility: 'hidden', height: '0', y: -20})
            .to(header.find('.tr-header__logo'), {opacity: 1, visibility: 'visible', height: '100%', y: 0}, '-=1')
        }
      }, 200)
    }
  })
}

export default mainMenu
